import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import '../styles/index.css';

function Index() {
  const [date, setDate] = useState(null);
  useEffect(() => {
    async function getDate() {
      const res = await fetch('/api/date');
      const newDate = await res.text();
      setDate(newDate);
    }
    getDate();
  }, []);
  return (
    <main>
      <Helmet>
        <title>etut.app</title>
      </Helmet>
      <h1>etut.app</h1>
      <h2>
        <span>private tutoring, consultancy and mentorship </span>
        <a
          href="https://www.notion.so/d4e233b0db4c49c3a96c22668dda78a2?v=6ddcaef093e94d058ad64360daea6eed"
          target="_blank"
          rel="noreferrer noopener"
        >directory!</a>
      </h2>
      <p>
        <span>Here you can add yourself as a private tutor who serves expertise online via digital tools like; Superpeer, Zoom or Youtube.</span>
      </p>
      <p>
        <h3>
          <a
            href="https://www.notion.so/milkers/etut-app-F-A-Q-599ecae533664312a6c0878df84d8a1f"
            target="_blank"
            rel="noreferrer noopener"
          >F.A.Q</a>
        </h3>
        <span></span>
      </p>
      <br />
      <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdXTldZPEArdW-sm2oxi5DYyHRgvclPRP-qCmhDvzzpPGaspQ/viewform?embedded=true" width="640" height="1575" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
    </main>
  );
}

export default Index;
